import { defineMessages } from 'react-intl';

const messages = defineMessages({
  readMore: { id: 'readMore', defaultMessage: 'Read more' },
  listingFootnote: {
    id: 'listingFootnote',
    defaultMessage: 'Internal link (select object) or external URL',
  },

  statisticsSettings: { id: 'statisticsSettings', defaultMessage: 'Settings' },
  headerBackgroundImage: {
    id: 'headerBackgroundImage',
    defaultMessage: 'Background image',
  },
  statisticsColumns: {
    id: 'statisticsColumns',
    defaultMessage: 'Number of columns',
  },
  statisticsAlignment: {
    id: 'statisticsAlignment',
    defaultMessage: 'Alignment',
  },
  statisticsAnimation: {
    id: 'statisticsAnimation',
    defaultMessage: 'Show animation',
  },
  statisticsBackgroundColor: {
    id: 'statisticsBackgroundColor',
    defaultMessage: 'Background color',
  },
  statisticsElement: {
    id: 'statisticsElement',
    defaultMessage: 'Statistics Element',
  },
  statisticsElementAdd: {
    id: 'statisticsElementAdd',
    defaultMessage: 'Add statistics element',
  },
  statisticsElementValue: {
    id: 'statisticsElementValue',
    defaultMessage: 'Value',
  },
  statisticsElementInfo: {
    id: 'statisticsElementInfo',
    defaultMessage: 'Additional info',
  },
  statisticsElementRemove: {
    id: 'statisticsElementRemove',
    defaultMessage: 'Remove',
  },
  statisticsAlignmentLeft: {
    id: 'statisticsAlignmentLeft',
    defaultMessage: 'Left',
  },
  statisticsAlignmentCenter: {
    id: 'statisticsAlignmentCenter',
    defaultMessage: 'Center',
  },
  statisticsAlignmentRight: {
    id: 'statisticsAlignmentRight',
    defaultMessage: 'Right',
  },

  headerTitle: { id: 'headerTitle', defaultMessage: 'Title' },
  headerDescription: { id: 'headerDescription', defaultMessage: 'Description' },
  fullWidth: { id: 'fullWidth', defaultMessage: 'Full width' },
  welcomeFootnoteText: {
    id: 'welcomeFootnoteText',
    defaultMessage: 'Footnote Text',
  },

  welcomeFootnoteLinks: {
    id: 'welcomeFootnoteLinks',
    defaultMessage: 'Any number of links, displayed separated by |',
  },

  linkItemSchemaGoal: { id: 'linkItemSchemaGoal', defaultMessage: 'Goal' },

  quoteContent: { id: 'quoteContent', defaultMessage: 'Content' },
  quoteQuote: { id: 'quoteQuote', defaultMessage: 'Quote' },
  quoteDesc: {
    id: 'quoteDesc',
    defaultMessage: 'Enter without quotation marks.',
  },
  quoteAuthor: { id: 'quoteAuthor', defaultMessage: 'Author' },
  quoteStil: { id: 'quoteStil', defaultMessage: 'Style' },

  teaserHeadtitle: { id: 'teaserHeadtitle', defaultMessage: 'Headtitle' },
  teaserOverrideImage: { id: 'teaserOverrideImage', defaultMessage: 'Image' },
  teaserButton: { id: 'teaserButton', defaultMessage: 'Show no button' },

  timelineElements: {
    id: 'timelineElements',
    defaultMessage: 'Timeline Elements',
  },
  timelineElementPosition: {
    id: 'timelineElementPosition',
    defaultMessage: 'Position',
  },
  timelineElementTitle: {
    id: 'timelineElementTitle',
    defaultMessage: 'Title',
  },
  timelineElementDescription: {
    id: 'timelineElementDescription',
    defaultMessage: 'Description',
  },
  timelineElementImage: {
    id: 'timelineElementImage',
    defaultMessage: 'Image (optional)',
  },

  contactChoiceSalutation: {
    id: 'contactChoiceSalutation',
    defaultMessage: 'Salutation',
  },
  contactChoiceName: {
    id: 'contactChoiceName',
    defaultMessage: 'Name',
  },
  contactChoiceSurname: {
    id: 'contactChoiceSurname',
    defaultMessage: 'Surname',
  },
  contactChoiceEmail: {
    id: 'contactChoiceEmail',
    defaultMessage: 'Email',
  },
  contactChoicePhone: {
    id: 'contactChoicePhone',
    defaultMessage: 'Phone',
  },
  contactChoiceInstitution: {
    id: 'contactChoiceInstitution',
    defaultMessage: 'Institution',
  },
  contactBlockFaculty: {
    id: 'contactBlockFaculty',
    defaultMessage: 'Subject Areas',
  },
  contactBlockDepartment: {
    id: 'contactBlockDepartment',
    defaultMessage: 'Department',
  },

  contactBlockImage: {
    id: 'contactBlockImage',
    defaultMessage: 'Image',
  },

  contactBlockHeadline: {
    id: 'contactBlockHeadline',
    defaultMessage: 'Optional headline above',
  },
  contactChoose: {
    id: 'contactChoose',
    defaultMessage: 'Choose contact',
  },
  contactFieldsDisplay: {
    id: 'contactFieldsDisplay',
    defaultMessage: 'Fields to display',
  },
  contactFieldsDisplayDescription: {
    id: 'contactFieldsDisplayDescription',
    defaultMessage: 'Visible fields',
  },

  contactLoading: {
    id: 'contactLoading',
    defaultMessage: 'Contact Loading...',
  },

  contactInstitutionHeadline: {
    id: 'contactInstitutionHeadline',
    defaultMessage: 'Institution Headline (optional)',
  },

  contactInstitutionDesc: {
    id: 'contactInstitutionDesc',
    defaultMessage: 'If empty, only the institution name will be displayed.',
  },

  contactChoiceRole: { id: 'contactChoiceRole', defaultMessage: 'Role' },
  contactChoiceDepartment: {
    id: 'contactChoiceDepartment',
    defaultMessage: 'Department',
  },
  contactChoiceFunctions: {
    id: 'contactChoiceFunctions',
    defaultMessage: 'Functions',
  },
  contactChoiceStreet: { id: 'contactChoiceStreet', defaultMessage: 'Street' },
  contactChoicePostalCode: {
    id: 'contactChoicePostalCode',
    defaultMessage: 'Postal Code',
  },
  contactChoiceLocation: {
    id: 'contactChoiceLocation',
    defaultMessage: 'Location',
  },
  contactChoiceRoom: {
    id: 'contactChoiceRoom',
    defaultMessage: 'Room',
  },

  contactChoicePriority: {
    id: 'contactChoicePriority',
    defaultMessage: 'Research Priorities',
  },
  contactChoiceImage: { id: 'contactChoiceImage', defaultMessage: 'Image' },

  contactColor: { id: 'contactColor', defaultMessage: 'Color scheme' },

  contactToggleOpen: {
    id: 'contactToggleOpen',
    defaultMessage: 'Open contact',
  },

  contactToggleClose: {
    id: 'contactToggleClose',
    defaultMessage: 'Close',
  },

  fcmhHighlightHeight: {
    id: 'fcmhHighlightHeight',
    defaultMessage: 'Fix blockwidth',
  },

  fcmhHighlightNoContent: {
    id: 'fcmhHighlightNoContent',
    defaultMessage:
      'FCMH: Highlight – please maintain the content in the sidebar form.',
  },

  fcmhHighlight50Cap: {
    id: 'fcmhHighlight50Cap',
    defaultMessage: 'Limit the content to approximately 50% width.',
  },

  fcmhHorizontalAlignment: {
    id: 'fcmhHorizontalAlignment',
    defaultMessage: 'Horizontal alignment',
  },

  fcmhVerticalAlignment: {
    id: 'fcmhVerticalAlignment',
    defaultMessage: 'Vertical alignment',
  },

  fcmhHighlightLeft: { id: 'fcmhHighlightLeft', defaultMessage: 'Left' },

  fcmhHighlightCenter: { id: 'fcmhHighlightCenter', defaultMessage: 'Center' },

  fcmhHighlightRight: { id: 'fcmhHighlightRight', defaultMessage: 'Right' },

  fcmhHighlightTop: { id: 'fcmhHighlightTop', defaultMessage: 'Top' },

  fcmhHighlightMiddle: { id: 'fcmhHighlightMiddle', defaultMessage: 'Middle' },

  fcmhHighlightBottom: { id: 'fcmhHighlightBottom', defaultMessage: 'Bottom' },

  brandBlockTitle: {
    id: 'brandBlockTitle',
    defaultMessage: 'FCMH Brand',
  },
  brandSettings: {
    id: 'brandSettings',
    defaultMessage: 'Settings',
  },

  brandLayoutTitle: {
    id: 'brandLayoutTitle',
    defaultMessage: 'Layout',
  },
  brandLayoutThree: {
    id: 'brandLayoutThree',
    defaultMessage: '3 rows',
  },
  brandLayoutSix: {
    id: 'brandLayoutSix',
    defaultMessage: '6 rows',
  },

  brandBehaviorTitle: {
    id: 'brandBehaviorTitle',
    defaultMessage: 'Behavior',
  },
  brandBehaviorDescription: {
    id: 'brandBehaviorDescription',
    defaultMessage: 'Variant switching behavior',
  },
  brandBehaviorStatic: {
    id: 'brandBehaviorStatic',
    defaultMessage: 'Static (no change)',
  },
  brandBehaviorReload: {
    id: 'brandBehaviorReload',
    defaultMessage: 'Random on page reload',
  },
  brandBehaviorInterval: {
    id: 'brandBehaviorInterval',
    defaultMessage: 'Random every X seconds',
  },

  brandIntervalTitle: {
    id: 'brandIntervalTitle',
    defaultMessage: 'Interval (seconds)',
  },
  brandIntervalDescription: {
    id: 'brandIntervalDescription',
    defaultMessage: 'Interval in seconds for automatic variant switching',
  },

  brandColumnLabel: {
    id: 'brandColumnLabel',
    defaultMessage: 'Column',
  },
  brandColorTitle: {
    id: 'brandColorTitle',
    defaultMessage: 'Color',
  },
  brandColorDescription: {
    id: 'brandColorDescription',
    defaultMessage: 'Bar color',
  },
  brandColorBlack: {
    id: 'brandColorBlack',
    defaultMessage: 'Black',
  },
  brandColorPetrol: {
    id: 'brandColorPetrol',
    defaultMessage: 'Petrol',
  },
  brandColorWhite: {
    id: 'brandColorWhite',
    defaultMessage: 'White',
  },
  brandColorPurple: {
    id: 'brandColorPurple',
    defaultMessage: 'Purple',
  },

  brandColumnsTitle: {
    id: 'brandColumnsTitle',
    defaultMessage: 'Columns',
  },
  brandColumnsDescription: {
    id: 'brandColumnsDescription',
    defaultMessage: 'The number of columns to display side by side',
  },
  brandColumnsOne: {
    id: 'brandColumnsOne',
    defaultMessage: 'One column',
  },
  brandColumnsTwo: {
    id: 'brandColumnsTwo',
    defaultMessage: 'Two columns',
  },
  brandColumnsThree: {
    id: 'brandColumnsThree',
    defaultMessage: 'Three columns',
  },

  brandRowColorTitle: {
    id: 'brandRowColorTitle',
    defaultMessage: 'Row {row}',
  },

  blockWidthCustom: { id: 'blockWidthCustom', defaultMessage: 'Block width' },

  footerContactLink: { id: 'footerContactLink', defaultMessage: 'Contact' },
  footerImprintLink: { id: 'footerImprintLink', defaultMessage: 'Imprint' },
  footerPrivacyLink: {
    id: 'footerPrivacyLink',
    defaultMessage: 'Privacy Policy',
  },
  footerCopyright: {
    id: 'footerCopyright',
    defaultMessage:
      'Plone® Open Source Content Management System © 2000–2025 Plone Foundation and friends.',
  },
  footerLicence: {
    id: 'footerLicence',
    defaultMessage: 'Licensed under the GNU GPL license.',
  },
});

export default messages;
